const fr = {
  'authoring.WELCOME_TITLE': 'Bonjour partenaire! Comment ça va?',
};

export default fr;
